import Cleave from 'cleave.js/react'
import { Props } from 'cleave.js/react/props'
import React from 'react'

export const CleaveTextField = React.forwardRef<any, Props>((props, ref) => {
    return <Cleave {...props} htmlRef={ref as any} />
})
